/**
 * Date utility functions for consistent date formatting across the application
 */
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const formatISOStringToReadable = (isoString) => {
  const [datePart, timePart] = isoString.split("T");
  const [year, month, day] = datePart.split("-").map(Number);
  const [hour, minute] = timePart.split(":");

  return `${monthNames[month - 1]} ${day}, ${year} ${hour}:${minute}`;
};

export const formatISOStringToReadableDateOnly = (isoString) => {
  const [datePart] = isoString.split("T");
  const [year, month, day] = datePart.split("-").map(Number);

  return `${monthNames[month - 1]} ${day}, ${year}`;
};

/**
 * Convert a Date object from DatePicker and a time string (HH:mm or HH:mm:ss) to ISO 8601 string
 * @param {Date|string} date - Date object (from DatePicker) or string "YYYY-MM-DD"
 * @param {string} timeStr - Time string in HH:mm or HH:mm:ss
 * @returns {string} ISO 8601 string like "YYYY-MM-DDTHH:mm:ss.000Z"
 */
export const toISO = (date, timeStr) => {
  let dateStr;

  // Nếu date là Date object, lấy YYYY-MM-DD thủ công
  if (date instanceof Date) {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    dateStr = `${yyyy}-${mm}-${dd}`;
  } else {
    dateStr = date; // đã là string "YYYY-MM-DD"
  }

  // Xử lý time string
  let [hours, minutes, seconds = "00"] = timeStr.split(":");
  hours = hours.padStart(2, "0");
  minutes = minutes.padStart(2, "0");
  seconds = seconds.padStart(2, "0");

  // Ghép thành ISO string thủ công
  return `${dateStr}T${hours}:${minutes}:${seconds}.000Z`;
};

export const getLocalDateString = (date) => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};
